import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaire-templates/{creatorId}/field-templates/{fieldTemplateId}']['PUT'];
type Input = ThisApi['params'] & { data: ThisApi['body'] };

const updateFieldTemplate = async ({ creatorId, fieldTemplateId, data: body }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaire-templates/{creatorId}/field-templates/{fieldTemplateId}', {
    creatorId,
    fieldTemplateId,
  });
  const data = await formsBackendClient.put(path, body);
  return data.data;
};

export default updateFieldTemplate;
